import { ITERATION_STATUS } from 'consts/project.const';
import styles from './ProjectIterationStatus.module.css';

const ProjectIterationStatus = ({ status }) => {
  if (!status) return null;
  return (
    <div>
      {status.status === ITERATION_STATUS.NOT_STARTED && (
        <div className={styles.not_started}>Не начат</div>
      )}
      {status.status === ITERATION_STATUS.IN_PROGRESS && (
        <div className={styles.in_progress}>В процессе</div>
      )}
      {status.status === ITERATION_STATUS.COMPLETED && (
        <div className={styles.complete}>Завершён</div>
      )}
      {status.status === ITERATION_STATUS.FORCECOMPLETED && (
        <div className={styles.force_complete}>Остановлен</div>
      )}
    </div>
  );
};

export default ProjectIterationStatus;
